import { createStore } from 'vuex';
import customer from './Customer/index';
import webflow from './Webflow/index';
import utilities from './Utilities/index';
import ops from './Ops/index';
import dashboard from './Dashboard/index';
import application from './Application/index';
import gstin from './Gstin/index';
import loan from './Loan/index';
import dualDocument from './DualDocument/index';
import eMandate from './EMandate/index';
import digiLocker from './DigiLocker/index';
import card from './Card/index';
import gPay from './gPay/index';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    customer,
    webflow,
    utilities,
    ops,
    application,
    dashboard,
    gstin,
    loan,
    dualDocument,
    eMandate,
    digiLocker,
    card,
    gPay
  },
});
